import { createStyles, makeStyles } from '@material-ui/styles';
import SpringBackgroundPattern from '../../../assets/background/loginLayout/loginBackgroundSpring.svg';
import AutumnBackgroundPattern from '../../../assets/background/loginLayout/loginBackgroundAutumn.svg';
import palette from '../../../theme/palette';
import { CURRENT_CHALLENGE_SEASON } from 'helpers/challenge/getChallengeInfos';

const style = () =>
  createStyles({
    root: {
      color: palette.text.white,
      backgroundImage: `url(${
        CURRENT_CHALLENGE_SEASON === 'autumn'
          ? AutumnBackgroundPattern
          : SpringBackgroundPattern
      })`,
      backgroundSize: 'cover',
      position: 'absolute',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0',
      padding: '60px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '10px',
      userSelect: 'none',
      '@media (max-height: 700px)': {
        justifyContent: 'space-around',
        bottom: 'auto',
        margin: '0',
        minHeight: '100vh',
        padding: '40px'
      },
      '@media (max-width: 768px)': {
        justifyContent: 'flex-start',
        bottom: 'auto',
        margin: '0',
        padding: '20px',
        minHeight: '100vh'
      }
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      gap: '40px',
      flexWrap: 'wrap',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        alignItems: 'start',
        gap: '30px'
      }
    },
    footer: {
      position: 'absolute',
      bottom: '10px',
      right: '0',
      left: '0',
      display: 'flex',
      justifyContent: 'center',
      '@media (max-width: 768px)': {
        position: 'static',
        marginTop: '50px'
      },
      '@media (max-height: 800px)': {
        position: 'static',
        marginTop: '50px'
      }
    },
    littleText: {
      fontSize: '0.625rem'
    },
    help: {
      fontSize: '0.875rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      '@media (max-width: 768px)': {
        paddingLeft: '20px'
      }
    },
    title: {
      fontSize: '2.5rem',
      margin: '0',
      '@media (max-width: 768px)': {
        fontSize: '1.75rem'
      }
    },
    space: {
      marginBottom: '5px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
